import { Renderer } from "./renderer";
/**
 * 单一渲染
 */
export class SimpleRenderer extends Renderer {
    /**
     * 根据矢量要素获取渲染符号
     * @param {Feature} feature - 矢量要素
     * @return {Symbol} 返回渲染符号
     */
    getSymbol(feature) {
        return this.symbol;
    }
}
